<div *ngIf="show" class="progress-container">
  <div class="progress-overlay"></div>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
